import { render } from "./HomeRoutePortal.vue?vue&type=template&id=14f53b58&scoped=true"
import script from "./HomeRoutePortal.vue?vue&type=script&lang=js"
export * from "./HomeRoutePortal.vue?vue&type=script&lang=js"

import "./HomeRoutePortal.vue?vue&type=style&index=0&id=14f53b58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f53b58"]])

export default __exports__